import { css } from '@emotion/react'

export const styles = {
  cardBody: css`
    min-height: 187px;
  `,
}
